const html = require('nanohtml')
const raw = require('nanohtml/raw')
const _ = require('morphable')

const Search = _(({ needle, search }) => html`<div class="level"><input class="input" type="text" value=${needle} oninput=${e => search(e.target.value)} placeholder="Filter by keywords..."><span class="is-small delete" onclick=${() => search()}></span></div>`)

module.exports = Search